module.exports = __webpack_public_path__ + "static/media/favicon.412da6d8.ico";